<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11.554"
    height="8.54"
    viewBox="0 0 11.554 8.54"
  >
    <path
      id="checkbox_check"
      d="M21.547,11.5l1.507,1.507L16.031,20.04,11.5,15.519l1.507-1.507,3.024,3.014Z"
      transform="translate(-11.5 -11.5)"
      :fill="clr ? clr : '#fff'"
    />
  </svg>
</template>
